import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Services } from './components/services'
import { Product } from './components/product'
import JsonData from './data/data.json'
import SmoothScroll from 'smooth-scroll'
import { OurValues } from './components/ourvalues'
import Footer from './components/footer'
import About from './components/about'
import { Contact } from './components/contact'
import { DeepTechSection } from './components/DeepTechSection'
import { OpenSourceSection } from './components/OpenSourceSection'



export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const Firstpage = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (

    <div>

    <Navigation />
       <Header data={landingPageData.Header} />
       <About data={landingPageData.About} />
       <DeepTechSection />
       <Product />
       <Services data={landingPageData.Services} />
       <OpenSourceSection />
       <OurValues />
       <Contact />
       <Footer />
     </div>



  )
}

export default Firstpage
